import React, { Component } from 'react';
import Tabs from './tabs';
import LazyLoad from 'react-lazyload';

export default class Milestones extends Component {

    render() {
        return (
            <LazyLoad>
                <Tabs />
            </LazyLoad>
        );
    }
}